export default __webpack_public_path__ + "static/media/6.bb093027.png";